import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { MODELO_DANFE_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll() {
  return doGetQCXRequest([
    MODELO_DANFE_ENDPOINT,
  ]);
}

async function fetchById(id) {
  return doGetQCXRequest([
    MODELO_DANFE_ENDPOINT,
    id,
  ]);
}

async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [MODELO_DANFE_ENDPOINT],
    data,
    queryParams
  );
}

async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [MODELO_DANFE_ENDPOINT],
    data,
    queryParams
  );
}

async function activateById(id) {
  return doPutQCXActivateRequest(
    [MODELO_DANFE_ENDPOINT],
    id
  );
}

async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [MODELO_DANFE_ENDPOINT],
    id
  );
}

export {
  fetchAll,
  fetchById,
  register,
  save,
  activateById,
  inactivateById,
};
